import request from '@/services/request';

export const get = id => request.get(`content-links/all/${id || ''}`);

export const create = data => request.post('content-links', data);

export const update = data => request.put(`content-links/${data.id}`, data);

export const deleteItem = data => request.delete(`content-links/${data.id}?linkType=${data.linkType}`);

export const reorder = data => request.post('content-links/reorder', data);

export const changeVisibility = data => request.put(`content-links/${data.id}/change-visibility`, data);

export const copy = data => request.put(`content-links/${data.id}/copy`, data);
